export default __webpack_public_path__ + "static/brcc-hero-left-805f98099dae4e7d4800244dc916a2ff.avif";